import { Component } from '@angular/core';
import { Network } from '@ionic-native/network';
import { Platform } from 'ionic-angular';

import { OfflineProvider } from '../../providers';

@Component({
  selector: 'offline',
  templateUrl: 'offline.html'
})
export class OfflineComponent {

  public isOffline: boolean = false;

  constructor(
    network: Network,
    offline: OfflineProvider,
    platform: Platform
  ) {
    platform.ready().then(() => {

      network.onDisconnect().subscribe(() => {
        this.isOffline = true;
      });

      network.onConnect().subscribe(() => {
        this.isOffline = false;
      });

    });

    offline.isOffline().subscribe((response) => {
      this.isOffline = response;
    });
  }

  setOnline()
  {
    this.isOffline = false;
  }

  setOffline()
  {
    this.isOffline = true;
  }
}



// WEBPACK FOOTER //
// ./src/components/offline/offline.ts